import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = ({ code = 404 }) => {
  const message =
    code === 403
      ? "You don’t have permission to access this page."
      : "Sorry, the page you are looking for was not found.";

  return (
    <div style={{ textAlign: "center", marginTop: "80px" }}>
      <h1>{code}</h1>
      <p>{message}</p>
      <Link to="/" className="btn btn-primary">
        Go Back Home
      </Link>
    </div>
  );
}; 

export default PageNotFound;